import { IPalette, IPaletteProvider } from "../bpmn-js/bpmn-js";

export class CustomPaletteProvider implements IPaletteProvider {

  static readonly $inject = ['palette', 'originalPaletteProvider', 'elementFactory', 'create'];
  private readonly elementFactory: any;
  private readonly create: any;

  constructor(private readonly palette: IPalette, private readonly originalPaletteProvider: IPaletteProvider, elementFactory, create) {
    palette.registerProvider(this);
    this.elementFactory = elementFactory;
    this.create = create;
  }

  getPaletteEntries() {
    let value = JSON.parse(localStorage.getItem('palletData'));
    let actions = {};
    for (let count = 0; count < value.length; count++) {
      for (let modelCnt = 0; modelCnt < value[count].modelData.length; modelCnt++) {
        actions['create.' + value[count].modelData[modelCnt].modelName + '-task'] =
        {
          group: 'activity',
          className: ['icon-custom-' + value[count].modelData[modelCnt].modelName],
          title: value[count].modelData[modelCnt].modelName,
          action: {
            click: () => {
              this.createShape(value, count, modelCnt);
            },
            dragstart: () => {
              this.createShape(value, count, modelCnt);
            }
          }
        } 
      }
    }
    return actions;
  }

  createShape(value, count: number, modelCnt: number) {
    let shape = this.elementFactory.createShape({
      type: 'bpmn:Task',
      modelName: value[count].modelData[modelCnt].modelName,
      modelId: value[count].modelData[modelCnt].modelId,
      modelType: 'custom',
      modelImg: value[count].modelData[modelCnt].modelImage,
      modelVersion: value[count].modelData[modelCnt].modelVersion,
      height: 300,
      width: 300
    });
    this.create.start(window.event, shape)
  }
}
